export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=405906ffc32c8ab75c2d51a907653ce0a72ccb8e4d&name=addToFolderEventAction!'